import { FC, Fragment } from 'react';
import { Reorder } from 'framer-motion';
import { PDFImageProps } from '../../../utils/models';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import Button from '../../themed/button';
import ReorderItem from '../../common/reorderItem';
import PDRTReportForm from '../../forms/custom-drt/pdrtReportForm';

interface PDRTItem {
	id: number;
	zoneNumber: string;
	scanNumber: string;
	source: string;
	sourceSerialNumber: string;		
	location: string;
	nominalThickness: string | number;
	corrosionAllowance: string | number;
	thickness: number;
	rtTechnique: string;
	sourceSize: string;
	sourceActivity: string;
	contrastUsed: string;
	drtScannerName: string;
	drtScannerSerialNumber: string;
	inspectionDate: Date;
	drtScannerCalibrationDate: Date;
	sourceConformityInspectionDate: Date;
	imageFilmType: string;
	pipeDia: number;
	comparatorLocation: string;
	sdd: string;
	odd: string;
	exposureTime: string;
	sourceManufacturer: string;
	materialSpecification: string;
	defect: string;
	defectType: string;
	defectLength: string;
	comparatorBallSize: number;
	result: string;
	limitation: string;
	remark: string;
	image: PDFImageProps[];
};

interface DRTSummaryItemsProps {
	reportItems: PDRTItem[];
	onDataChange: (items: PDRTItem[]) => void;
}

const PDRTReportItems: FC<DRTSummaryItemsProps> = (props) => {
	const handleAddItem = (reportItem: PDRTItem) => {
		const newDRTItem = {
			...reportItem,
			id: props.reportItems.length + 1,
		};

		props.onDataChange([...props.reportItems, newDRTItem]);
	};

	const handleDeleteItem = (item: PDRTItem): void => {
		const newReportItems = props.reportItems.filter((reportItem) => reportItem.id !== item.id);
		props.onDataChange(newReportItems);
	};

	const handleEditItem = (originalItem: PDRTItem, updatedItem: PDRTItem): void => {
		const newReportItems = props.reportItems.map((reportItem) => reportItem.id === originalItem.id ? { ...reportItem, ...updatedItem } : reportItem); 
		props.onDataChange(newReportItems);
	};

	const handleDuplicateItem = (item: PDRTItem, index: number) => {
		const newDRTItem = {
			...item,
			id: props.reportItems.length + 1,
		};

		const newReportItems = [...props.reportItems.slice(0, index), newDRTItem, ...props.reportItems.slice(index)];
		props.onDataChange(newReportItems);
	};

	return (
		<Fragment>
			<CustomNewItem label='Create New PDRT Item'>
				<PDRTReportForm onSave={handleAddItem} />
			</CustomNewItem>

			<div className="divider my-4"></div>

			<Reorder.Group className='list-unstyled' values={props.reportItems} onReorder={props.onDataChange}>
				{props.reportItems.map((item, index) => (
					<ReorderItem key={item.id} value={item}>
						<AccordionItem title={item.location + ' ' + item.zoneNumber + ' ' + item.scanNumber} isActive>
							<div className="d-flex justify-content-end align-items-center">
								<div className="bg-light p-2 border rounded">
									<Button
										icon="clipboard-plus-fill"
										label="Duplicate"
										style={{ marginTop: 0 }}
										onClick={() => handleDuplicateItem(item, index)}
									/>
								</div>
							</div>

							<div className="divider my-4"></div>

							<PDRTReportForm 
								initialPDRTItem={item}
                                onDeleteItem={() => handleDeleteItem(item)}
								onSave={(updatedItem: PDRTItem) => handleEditItem(item, updatedItem)}
							/>
						</AccordionItem>
					</ReorderItem>
				))}
			</Reorder.Group>
		</Fragment>
	);
};

export type { PDRTItem };
export default PDRTReportItems;
